import { render } from "./BookLabel.vue?vue&type=template&id=69b73622&scoped=true"
import script from "./BookLabel.vue?vue&type=script&lang=js"
export * from "./BookLabel.vue?vue&type=script&lang=js"

import "./BookLabel.vue?vue&type=style&index=0&id=69b73622&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b73622"]])

export default __exports__